/** Upcoming-panel unlock persistence for TodayView. */
const UPCOMING_UNLOCK_KEY = 'todoes.today.upcomingUnlockedDate';

export const getTodayDateKey = () => new Date().toDateString();

export const readUpcomingUnlocked = () => {
  try {
    return window.localStorage.getItem(UPCOMING_UNLOCK_KEY) === getTodayDateKey();
  } catch {
    return false;
  }
};

export const persistUpcomingUnlocked = () => {
  try {
    window.localStorage.setItem(UPCOMING_UNLOCK_KEY, getTodayDateKey());
  } catch {
    // storage unavailable, unlock still holds for this session
  }
};
